<template>
  <div class="container_cascader_meun">
    <div class="pop" @click="openMeun(isOpenFlag, true)"></div>
    <div class="cascader_meun_box">
      <div class="cascader_meun_border">
        <!-- <el-cascader-panel
          :options="datas"
          :value="valueArr"
          :props="props"
          @change="changeEvent"
        ></el-cascader-panel> -->
        <cascaderSelectPop
          :meunList="datas"
          :valueArr="valueArr"
          :loadChildCallback="loadChildCallback"
          :isShowSearch="isShowSearch"
          @change="changeEvent"
          @isShowSearchEvent="isShowSearchEventHandler"
        ></cascaderSelectPop>
      </div>
    </div>
  </div>
</template>

<script>
import cascaderSelectPop from '@components/base/cascaderSelectPop'
export default {
  name: 'container_cascader_meun',
  components: { cascaderSelectPop },
  props: {
    curValArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    isOpenFlag: {
      type: Boolean,
      default: false,
    },
    datas: {
      type: Array,
      default: () => {
        return []
      },
    },
    loadChildCallback: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    curValArr(newVal, oldVal) {
      console.debug(
        'change curValArr:',
        newVal,
        oldVal,
        JSON.stringify(newVal) !== JSON.stringify(oldVal)
      )
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.renderOptionsData()
      }
    },
    isOpenFlag(newVal, oldVal) {
      console.debug('change isOpenFlag:', newVal, oldVal)
      if (newVal && !oldVal) {
        if (newVal) {
          // 每次打开弹窗时，触发打开搜索框
          this.isShowSearchEventHandler(newVal)
        }
        this.renderOptionsData()
      }
    },
    immediate: true,
    deep: true,
  },
  data() {
    return {
      isShowSearch: false,
      valueArr: [],
      // options: [
      //   {
      //     value: 'zhinan',
      //     label: '指南指南指南指南指南',
      //     children: [
      //       {
      //         value: 'shejiyuanze',
      //         label: '设计原则',
      //         children: [
      //           {
      //             value: 'yizhi',
      //             label: '一致',
      //           },
      //           {
      //             value: 'fankui',
      //             label: '反馈',
      //           },
      //           {
      //             value: 'xiaolv',
      //             label: '效率',
      //           },
      //           {
      //             value: 'kekong',
      //             label: '可控',
      //           },
      //         ],
      //       },
      //       {
      //         value: 'daohang',
      //         label: '导航',
      //         children: [
      //           {
      //             value: 'cexiangdaohang',
      //             label: '侧向导航',
      //             children: [
      //               {
      //                 value: 'layout',
      //                 label: 'Layout 布局',
      //               },
      //               {
      //                 value: 'color',
      //                 label: 'Color 色彩',
      //               },
      //               {
      //                 value: 'typography',
      //                 label: 'Typography 字体',
      //               },
      //               {
      //                 value: 'icon',
      //                 label: 'Icon 图标',
      //               },
      //               {
      //                 value: 'button',
      //                 label: 'Button 按钮',
      //               },
      //             ],
      //           },
      //           {
      //             value: 'dingbudaohang',
      //             label: '顶部导航',
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     value: 'zujian',
      //     label: '组件',
      //     children: [
      //       {
      //         value: 'basic',
      //         label: 'Basic',
      //         children: [
      //           {
      //             value: 'layout',
      //             label: 'Layout 布局',
      //           },
      //           {
      //             value: 'color',
      //             label: 'Color 色彩',
      //           },
      //           {
      //             value: 'typography',
      //             label: 'Typography 字体',
      //           },
      //           {
      //             value: 'icon',
      //             label: 'Icon 图标',
      //           },
      //           {
      //             value: 'button',
      //             label: 'Button 按钮',
      //           },
      //         ],
      //       },
      //       {
      //         value: 'form',
      //         label: 'Form',
      //         children: [
      //           {
      //             value: 'radio',
      //             label: 'Radio 单选框',
      //           },
      //           {
      //             value: 'checkbox',
      //             label: 'Checkbox 多选框',
      //           },
      //           {
      //             value: 'input',
      //             label: 'Input 输入框',
      //           },
      //           {
      //             value: 'input-number',
      //             label: 'InputNumber 计数器',
      //           },
      //           {
      //             value: 'select',
      //             label: 'Select 选择器',
      //           },
      //           {
      //             value: 'cascader',
      //             label: 'Cascader 级联选择器',
      //           },
      //           {
      //             value: 'switch',
      //             label: 'Switch 开关',
      //           },
      //           {
      //             value: 'slider',
      //             label: 'Slider 滑块',
      //           },
      //           {
      //             value: 'time-picker',
      //             label: 'TimePicker 时间选择器',
      //           },
      //           {
      //             value: 'date-picker',
      //             label: 'DatePicker 日期选择器',
      //           },
      //           {
      //             value: 'datetime-picker',
      //             label: 'DateTimePicker 日期时间选择器',
      //           },
      //           {
      //             value: 'upload',
      //             label: 'Upload 上传',
      //           },
      //           {
      //             value: 'rate',
      //             label: 'Rate 评分',
      //           },
      //           {
      //             value: 'form',
      //             label: 'Form 表单',
      //           },
      //         ],
      //       },
      //       {
      //         value: 'data',
      //         label: 'Data',
      //         children: [
      //           {
      //             value: 'table',
      //             label: 'Table 表格',
      //           },
      //           {
      //             value: 'tag',
      //             label: 'Tag 标签',
      //           },
      //           {
      //             value: 'progress',
      //             label: 'Progress 进度条',
      //           },
      //           {
      //             value: 'tree',
      //             label: 'Tree 树形控件',
      //           },
      //           {
      //             value: 'pagination',
      //             label: 'Pagination 分页',
      //           },
      //           {
      //             value: 'badge',
      //             label: 'Badge 标记',
      //           },
      //         ],
      //       },
      //       {
      //         value: 'notice',
      //         label: 'Notice',
      //         children: [
      //           {
      //             value: 'alert',
      //             label: 'Alert 警告',
      //           },
      //           {
      //             value: 'loading',
      //             label: 'Loading 加载',
      //           },
      //           {
      //             value: 'message',
      //             label: 'Message 消息提示',
      //           },
      //           {
      //             value: 'message-box',
      //             label: 'MessageBox 弹框',
      //           },
      //           {
      //             value: 'notification',
      //             label: 'Notification 通知',
      //           },
      //         ],
      //       },
      //       {
      //         value: 'navigation',
      //         label: 'Navigation',
      //         children: [
      //           {
      //             value: 'menu',
      //             label: 'NavMenu 导航菜单',
      //           },
      //           {
      //             value: 'tabs',
      //             label: 'Tabs 标签页',
      //           },
      //           {
      //             value: 'breadcrumb',
      //             label: 'Breadcrumb 面包屑',
      //           },
      //           {
      //             value: 'dropdown',
      //             label: 'Dropdown 下拉菜单',
      //           },
      //           {
      //             value: 'steps',
      //             label: 'Steps 步骤条',
      //           },
      //         ],
      //       },
      //       {
      //         value: 'others',
      //         label: 'Others',
      //         children: [
      //           {
      //             value: 'dialog',
      //             label: 'Dialog 对话框',
      //           },
      //           {
      //             value: 'tooltip',
      //             label: 'Tooltip 文字提示',
      //           },
      //           {
      //             value: 'popover',
      //             label: 'Popover 弹出框',
      //           },
      //           {
      //             value: 'card',
      //             label: 'Card 卡片',
      //           },
      //           {
      //             value: 'carousel',
      //             label: 'Carousel 走马灯',
      //           },
      //           {
      //             value: 'collapse',
      //             label: 'Collapse 折叠面板',
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     value: 'ziyuan',
      //     label: '资源',
      //     children: [
      //       {
      //         value: 'axure',
      //         label: 'Axure Components',
      //       },
      //       {
      //         value: 'sketch',
      //         label: 'Sketch Templates',
      //       },
      //       {
      //         value: 'jiaohu',
      //         label: '组件交互文档',
      //       },
      //     ],
      //   },
      // ],
    }
  },
  methods: {
    isShowSearchEventHandler(flag) {
      this.isShowSearch = flag
    },
    changeEvent(valArr) {
      console.debug('changeSportsEventId:', valArr)
      this.$emit('changeSportsEventId', valArr)
      this.openMeun(this.isOpenFlag)
    },
    openMeun(flag, isRenderData) {
      console.debug('clickIsOpenMeunEvent:', flag)
      if (flag) {
        //弹窗关闭，搜索框也收回
        this.isShowSearchEventHandler(false)
      }
      this.$emit('clickIsOpenMeunEvent', !flag)
      if (isRenderData) {
        this.renderOptionsData()
      }
    },
    renderOptionsData() {
      console.debug('重置数据:', this.curValArr)
      // this.valueArr = []
      this.$nextTick(() => {
        this.valueArr = JSON.parse(JSON.stringify(this.curValArr))
      })
    },
    loadChildEvent(needLoadValueArr) {
      this.$emit('loadOneEventMatchList', needLoadValueArr)
    },
  },
}
</script>

<style lang="scss" scoped>
.container_cascader_meun {
  .pop {
    position: fixed;
    top: 8vw;
    left: 0;
    z-index: 4000;
    width: 100%;
    height: calc(100vh - 3.884vw);
    background-color: var(--mixtmt_greyColor4);
  }
  .cascader_meun_box {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 4001;
    width: calc(100vw - 19.444vw);
    padding-bottom: 0.694vw;
    height: auto;
    margin-top: 5vw;
    transform: translate(-50%, -50%);
    background-color: var(--mixtmt_whiteColor);
    border-radius: 0.347vw;
    overflow: hidden;
    .cascader_meun_border {
      width: 100%;
      height: 56vh;
    }
  }
}
.mixtmt_pc .container_cascader_meun {
  .pop {
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.container_cascader_meun {
  .el-cascader-panel.is-bordered {
    border: 0;
    border-radius: 0;
  }
  .el-cascader-menu {
    min-width: 11.25vw;
    .el-cascader-menu__wrap {
      height: 25vw;
      .el-cascader-menu__list {
        padding: 0.8vw 0.347vw;
      }
    }
    .el-cascader-node {
      padding: 0 2.778vw 0 1.388vw;
      font-size: 0.972vw;
      height: 2.788vw;
      .el-cascader-node__label {
        padding: 0 1.388vw;
      }
      .el-cascader-node__postfix {
        right: 0.694vw;
      }
    }
    &:nth-child(4) {
      max-width: 55%;
      .el-cascader-node {
        padding: 0 1.388vw;
      }
    }
  }
  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: var(--mixtmt_mainColor);
  }
}
</style>
